module.exports = __webpack_public_path__ + "static/media/marker-red.c237ee81.svg";